    <button [disabled]="to.buttonOptions.disabled" [class.disabled]="to.buttonOptions.disabled" [type]="to.buttonOptions.type" class="btn" [ngClass]="to.buttonOptions.class || 'btn--default'" (click)="onClick($event)">
      <lu-icon [class.btn__ico]="to.buttonOptions.label" *ngIf="to.buttonOptions.icon" [icon]="to.buttonOptions.icon"></lu-icon>
      <span class="btn__txt" *ngIf="to.buttonOptions.label">{{ to.buttonOptions.label }}</span>
    </button>
